module.exports = __webpack_public_path__ + "static/media/sondos.323f4241.png";